export default [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'Control de pedidos',
    },
    component: () => import(/* webpackChunkName: "login" */ '@/views/Login'),
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import(/* webpackChunkName: "logout" */ '@/views/Logout'),
  },
]
